import { Stack } from '@mui/material'

import CustomTooltip from 'components/shared/CustomTooltip'
import { IGroupEntity } from 'models'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

const GroupSpecificData = (props: IGroupEntity) => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const isCattleQtyOverLimit =
		props.cattles_limit != null && props.cattles_qty > props.cattles_limit

	return (
		<Stack width='100%' gap='16px' marginTop='16px'>
			<Stack direction='row' alignItems='center' gap='6px'>
				<TypographySecondary14>Голов в группе:</TypographySecondary14>
				{props.cattles_qty == null ? (
					<TypographySecondary14>Нет данных</TypographySecondary14>
				) : (
					<TypographyPrimary
						sx={{ color: isCattleQtyOverLimit ? COLORS.error : undefined }}
					>
						{props.cattles_qty}
					</TypographyPrimary>
				)}
				{props.cattles_limit != null && (
					<>
						<TypographySecondary14>{`/ ${props.cattles_limit}`}</TypographySecondary14>
						<CustomTooltip
							width='16px'
							height='16px'
							info
							placement='top'
							title='Вместимость группы'
						/>
					</>
				)}
			</Stack>
			{permissions?.license_food_table && (
				<Stack direction='row' alignItems='center' gap='6px'>
					<TypographySecondary14>Рацион:</TypographySecondary14>
					<TypographyPrimary
						sx={{ color: props.rationtitle ? undefined : COLORS.error }}
					>
						{props.rationtitle || 'Не назначен'}
					</TypographyPrimary>
				</Stack>
			)}
			{permissions?.license_identification && (
				<Stack direction='row' alignItems='center' gap='6px'>
					<TypographySecondary14>Лактационный период:</TypographySecondary14>
					{props.lactation_period == null ? (
						<TypographySecondary14>Нет данных</TypographySecondary14>
					) : (
						<TypographyPrimary>
							{String(props.lactation_period).replace(/\s*-\s*/, ' - ')}
						</TypographyPrimary>
					)}
				</Stack>
			)}
		</Stack>
	)
}

export default GroupSpecificData
